import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { MessagingSummaryResponse } from 'src/app/messagingV3/legacy/models/messagingSummaryResponse';
import { ClinicSummaryResponse } from './../../models/responses/clinic-summary.response';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Label } from 'src/app/models/Label';
import * as fromRoot from '../../../reducers';
import * as fromMessages from '../../../messagingV3/legacy/reducers';
import * as fromSettings from '../../../settings/reducers';
import * as fromDashboard from '../../reducers';
import * as MessageActions from '../../../messagingV3/legacy/actions/message-ui.actions';
import { NavigationService } from '../../../core/services/navigation.service';

@Component({
  selector: 'portal-dashboard-folders',
  templateUrl: './dashboard-folders.component.html',
  styleUrls: ['./dashboard-folders.component.scss']
})
export class DashboardFoldersComponent {
  public messagingSummary$: Observable<MessagingSummaryResponse>;
  public labels$: Observable<{ name: string }[]>;
  public sectionText$: Observable<any>;
  public summary$: Observable<ClinicSummaryResponse>;

  constructor(
    private _store: Store<fromRoot.State>,
    private _navigationService: NavigationService
  ) {
    this.labels$ = this._store.pipe(select(fromMessages.getLabelNames));
    this.sectionText$ = this._store.pipe(
      select(fromSettings.getSectionTranslations('Dashboard'))
    );
    this.summary$ = this._store.pipe(select(fromDashboard.getDashboardSummary));
    this.messagingSummary$ = this._store.pipe(
      select(fromMessages.getMessagingSummary)
    );
  }

  public goToMessagesByLabel(label: string): void {
    // set label of messages to view
    this._store.dispatch(new MessageActions.ApplyFilter(label.toLowerCase()));
    // then open messages
    this._navigationService.navigate(['/messages']);
  }

  public goToMessagesByType(messageTypeId: number): void {
    this._store.dispatch(
      new MessageActions.ApplyMessageTypeFilter(
        new Label({
          messageTypeId,
          displayName: '',
          filter: '',
          isGroup: false
        })
      )
    );
    // then open messages
    this._navigationService.navigate(['/messages']);
  }
}
